import { Component, EventEmitter, Input, OnInit, Output  } from '@angular/core';
import { TableHeader } from './table-header';
import { QueryFilter } from '../models/query-filter.model';

@Component({
    selector: 'gt-table',
    templateUrl: './gt-table.component.html',
    styleUrls: ['./gt-table.component.scss'],
    standalone: false
})
export class GtTableComponent implements OnInit {
  @Input() filter?: QueryFilter = new QueryFilter();
  @Input() headers: TableHeader[];
  @Input() data: any = [];
  @Input() ignoreFields?: string[];
  @Input() resetFilter?: any;
  @Input() filtersTemplate?: string;
  @Input() resultsTemplate?: string;
  @Input() updateFilterEvent: EventEmitter<any>;
  @Input() loading?: boolean;
  @Input() defaultPageSize = 50;
  @Output() loadingChanged: EventEmitter<boolean>;
  @Output() filterChanged = new EventEmitter();
  @Output() filterReset = new EventEmitter();
  @Output() toggleFilter = new EventEmitter<any>();
  @Input() enableSearch = true;
  @Input() showFilterToggle = false;
  @Input() placeholder = 'Search...';
  isLoading = true;
  showFilters = false;
  displayedPageSize = '50';

  constructor() {
  }

  ngOnInit() {
    this.filter.pageSize = this.defaultPageSize;
    this.displayedPageSize = this.defaultPageSize.toString();
    if (this.ignoreFields === undefined || this.ignoreFields === null) {
      this.ignoreFields = [];
    }

    if (this.data.length === 0) {
      this.filter.page = 1;
      this.filter.pageMinimum = 1;
      this.filter.pageMaximum = 0;
      this.filter.totalCount = 0;
    } else {
      this.filter.pageMinimum = 1;
    }
    if (this.data.length > 0) {
      this.isLoading = false;
    }
    if (this.updateFilterEvent) {
      this.updateFilterEvent.subscribe((data) => {
        this.data = data;
        this.isLoading = false;
        this.updateFilter();
      });
    }

    this.updateFilter();
  }

  setPageSize(size: number): void {
    this.filter.pageSize = size;
    this.isLoading = true;
    this.filter.page = 1;
    this.filterChanged.emit();
  }

  objectKeys(obj) {
    return Object.keys(obj);
  }

  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  submit(): void {
    this.isLoading = true;
    this.filter.page = 1;
    this.filterChanged.emit();
  }

  reset(): void {
    this.displayedPageSize = this.defaultPageSize.toString();
    this.filter.pageSize = this.defaultPageSize;
    this.isLoading = true;
    this.filterReset.emit();
    this.filterChanged.emit();
  }

  getPreviousPage(): void {
    this.filter.page -= 1;
    this.isLoading = true;
    this.filterChanged.emit();
  }

  getNextPage(): void {
    this.filter.page += 1;
    this.isLoading = true;
    this.filterChanged.emit();
  }

  updateFilter(): void {
    if (this.data.length > 0) {
      this.filter.pageMinimum = this.filter.pageSize * (this.filter.page - 1) + 1;
      this.filter.pageMaximum = (this.filter.pageSize * this.filter.page) > this.filter.totalCount
        ? this.filter.totalCount
        : (this.filter.pageSize * this.filter.page);
    } else {
      this.filter.page = 1;
      this.filter.totalCount = 0;
      this.filter.pageMaximum = this.filter.pageSize * this.filter.page;
      this.filter.sortColumn = null;
      this.filter.sortDirection = 'ASC';
    }
    this.filter.pageMinimum = this.filter.pageSize * (this.filter.page - 1)  + 1;
  }

  validateEmail(email: string): boolean {
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<h2>()\[\]\\.,;:\s@"]+(\.[^<h2>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
